import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, useRouteMatch } from 'react-router-dom';
import { withForbidden } from '../../../../global/components/HOCs/with-forbidden';
import { withLayout } from '../../../../global/components/HOCs/with-layout';
import { LayoutModels } from '../../../../global/components/layout/layout-models';
import { setNavigationContext } from '../../../../global/ducks/app-context';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { TcsmFeatures } from '../../../../global/models/features-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import AccountInfoContainer from '../../../account-info/components/account-info-container';
import { AnnualEnrollmentRoutes } from '../../../annual-enrollment/constants/annual-enrollment-routes';
import { useAnnualEnrollmentSettings } from '../../../annual-enrollment/hooks/useAnnualEnrollmentSettings';
import { BillingAccount } from '../billing-accounts/billing-accounts-models';
import { useBillingAccountState } from '../billing-accounts/useBillingAccountsState';
import { useInsuranceGroups } from '../groups/useInsuranceGroups';
import { useMidYearState } from './hooks/useMidYearState';
import { MidYearConfirmation } from './mid-year-confirmation';
import { MidYearForm } from './mid-year-form';

const CoverageWrapper = withLayout(LayoutModels.FULL_WIDTH)(withForbidden(TcsmFeatures.MidYear)(AccountInfoContainer));

interface Props {
	annualEnrollmentSettingsId: string;
	hideRelationshipLink?: boolean
}
export function MidYearApp(props: Props) {
	const { annualEnrollmentSettingsId } = props;
	const routeMatch = useRouteMatch();
	const midYearLoaded = useMidYearState();
	const annualEnrollmentSettingsLoaded = useAnnualEnrollmentSettings(annualEnrollmentSettingsId);
	const groupId = useSelector<TcsmStates, number>(a => a.groupsState?.currentGroup?.group_id);
	const billingAccount = useSelector<TcsmStates, BillingAccount>(a => a.billingAccountsState?.currentBillingAccount);
	const groupsLoaded = useInsuranceGroups();
	const dispatch = useDispatch();
	useBillingAccountState(groupId);

	useEffect(() => {
		if (!billingAccount) {
			dispatch(setNavigationContext(NavigationContext.GroupAdmin));
		}
	}, []);

	if ((groupId && !midYearLoaded) || !annualEnrollmentSettingsLoaded || !groupsLoaded) {
		return <LoadingCircle />;
	}

	return (
		<>
			<Route exact path={routeMatch.path} render={() => (
				<CoverageWrapper basePath={routeMatch.path}>
					<MidYearForm hideRelationshipLink={props.hideRelationshipLink} />
				</CoverageWrapper>
			)} />
			<Route exact path={`${routeMatch.path}${AnnualEnrollmentRoutes.Confirmation}`} render={() => (
				<CoverageWrapper basePath={routeMatch.path}>
					<MidYearConfirmation />
				</CoverageWrapper>
			)} />

		</>
	);

}

MidYearApp.defaultProps = {
	hideRelationshipLink: false,
};